// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-video[data-v-18fc2710]{-o-object-fit:cover;object-fit:cover}.no-objectfit .bg-video[data-v-18fc2710]{-webkit-transform-origin:50% 50%;transform-origin:50% 50%;-webkit-transform:scale3d(2, 2, 2);transform:scale3d(2, 2, 2)}.absolute[data-v-18fc2710]{width:100%;height:100%;position:fixed;top:0;left:0;-webkit-transform-origin:50% 50%;transform-origin:50% 50%}", ""]);
// Exports
module.exports = exports;
